import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import usePrevious from 'utils/customHook/usePrevious';
import classNames from 'classnames';
import useCancellationToken from 'utils/customHook/useCancellationToken';

import ModuleSimpleInfo from './ModuleSimpleInfo';

import { nvl } from 'utils/nvl';

import { AreaContainer } from './ModuleIcon.css';
import ModuleStatusIcon from './ModuleStatusIcon';
import IconImage from './IconImage';

const ModuleIcon = ( props ) => {
  const cancellationToken = useCancellationToken();
  const dispatch = useDispatch();
  const [ viewOn, setViewOn ] = useState(false);
  const prevAmount = usePrevious(props.status, cancellationToken.isCancelled);

  // 위험알람 hooks 로직
  useEffect(() => {
    if (props.moduleStatus === 'blue') {
      if ((nvl(prevAmount, null) !== null && props.status !== 'blue' && prevAmount !== props.status)) {
        props.setAlertAnimationOn(true);
        dispatch({ type: 'ALERT_INSERT', 
                   data: {...props,
                          userPhone: '', 
                          confirm: props.alertConfirm}});
      }  
    }
  }, [props.status, cancellationToken])

  useEffect(() => () => cancellationToken.cancel(), []);

  return (
    <AreaContainer onMouseOver={() => {setViewOn(true)}} 
                   onMouseLeave={() => {setViewOn(false)}}
                   xcoordinate={props.xaxis} 
                   ycoordinate={props.yaxis}
                   scn={(props.moduleIdx === 118 || props.moduleIdx === 119 || props.moduleIdx === 120) ? '3' : props.moduleScn}
                   status={props.moduleStatus === 'blue' ? props.status : 'none'} 
                   alertAnimationOn={props.alertAnimationOn}
                 >
      <div className="areaBox">
        <div className={classNames({viewOn}, 'modules')}>
          {
            <ModuleSimpleInfo key={props.moduleIdx} 
                              alertConfirm={props.alertConfirm}
                              { ...props } />
          }  
        </div>
      </div>
      <ModuleStatusIcon battery={props.battery} 
                        moduleStatus={props.moduleStatus} />
      <IconImage alertAnimationOn={props.alertAnimationOn} 
                 moduleScn={props.moduleScn} 
                 moduleIdx={props.moduleIdx}
                 modelNm={props.modelNm}
                 areaNm={props.areaNm} />
    </AreaContainer>
  )
}

export default ModuleIcon;